import * as React from 'react'
import { compose, pure } from 'recompose'

import * as GrayLogoUrl from './assets/GrayLogo.png'
import * as LogoUrl from './assets/Logo.png'
import * as styles from './Logo.css'

export enum LogoType {
  WHITE,
  GRAY
}

interface LogoProps {
  type?: LogoType
}

const Logo: React.FunctionComponent<LogoProps> = ({ type = LogoType.WHITE }) => {
  if (type === LogoType.WHITE) {
    return <img className={styles.logo} src={LogoUrl} alt="logo" />
  }
  return <img className={styles.logo} src={GrayLogoUrl} alt="logo" />
}

export default compose<LogoProps, LogoProps>(pure)(Logo)
